import { render } from "./FilterPeriode.vue?vue&type=template&id=644068f3"
import script from "./FilterPeriode.vue?vue&type=script&lang=js"
export * from "./FilterPeriode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__